<div *ngIf="mode === 'property'">
  <comparables-property-infobar-pictures [data]="infobarItem[mode]"></comparables-property-infobar-pictures>
</div>
